import { render, staticRenderFns } from "./DashboardSupport.vue?vue&type=template&id=5735f59a&scoped=true&"
import script from "./DashboardSupport.vue?vue&type=script&lang=js&"
export * from "./DashboardSupport.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSupport.scss?vue&type=style&index=0&id=5735f59a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5735f59a",
  null
  
)

export default component.exports